import apinode from '../../apinode'

class CategoriesService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/categories/${this.idconta}`)

    return response.data
  }

  async getBySearch(search) {
    const response = await apinode.get(
      `/categories/${this.idconta}?search=${search}`,
    )

    return response.data
  }

  async create({ name }) {
    await apinode.post(`/categories/${this.idconta}`, {
      name,
    })
  }

  async update(id, { name }) {
    await apinode.put(`/categories/${id}/${this.idconta}`, {
      name,
    })
  }

  async delete(id) {
    await apinode.delete(`/categories//${id}/${this.idconta}`)
  }
}

export default new CategoriesService()
